export default {
  ID: 'REQUEST_ID_STEP',
  SIDEBAR_IMAGE: true,
  FOOTER: true,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};
